import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  const getRankColor = (rank: number): string => {
    if (rank === 1) return 'bg-primary-500';
    if (rank === 2) return 'bg-accent-500';
    if (rank === 3) return 'bg-secondary-500';
    return 'bg-background-300';
  };

  const getChangeColor = (change: string): string => {
    if (change === 'up') return 'text-primary-500';
    if (change === 'down') return 'text-foreground-400';
    return 'text-accent-500';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500">全网最热八卦实时排名，看看今天什么瓜最火</p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#updates"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('updates')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`flex items-center gap-4 p-4 cursor-pointer transition-colors ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-50`}
            >
              <span
                className={`w-8 h-8 flex items-center justify-center ${getRankColor(item.rank)} text-white rounded-lg text-sm font-bold shrink-0`}
              >
                {item.rank}
              </span>

              <p className="flex-1 text-sm text-foreground-800 leading-relaxed min-w-0">
                {item.title}
              </p>

              <div className="flex items-center gap-3 shrink-0">
                <span className={`flex items-center gap-0.5 text-xs ${getChangeColor(item.change)}`}>
                  <i className={`${item.changeIcon} text-xs`}></i>
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}